import { PayloadAction } from '@reduxjs/toolkit';
import { trackException } from 'app-insights/appInsightsTracking';
import { placementFlattenData } from 'app/components/GlobalSearch/Placement/SearchHelper';
import { ExceptionType } from 'app/enums/Common';
import { SearchType } from 'app/models/GlobalSearch/GlobalSearch';
import { getAMIECategorySearch } from 'app/services/SharedServices/SharedServices';
import { TFunction } from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import { call, put, takeLatest } from 'redux-saga/effects';
import { associatedPlacementActions } from './associatedPlacements.redux';
import { globalSearchActions } from 'store/redux-store/global-search/slice';
import { SortColumn } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { PlacementSearchFilterName } from '@AMIEWEB/GlobalSearch/Placement/SearchUtils';

const TrackWrapper = (fn, ...args) => trackPromise(fn(...args), 'concerned-placements');

export function* getPlacements(
  action: PayloadAction<{
    filter?: any;
    pageNumber: number;
    pageSize: number;
    sortedColumn?: { column: string; direction: 'asc' | 'desc' } | undefined | null;
    multiSortedColumns?: SortColumn[];
    translation: TFunction;
  }>,
) {
  try {
    const f = action.payload.filter || {};
    const rawZip = f[PlacementSearchFilterName.zip];
    const zipObj =
      rawZip && typeof rawZip === 'object' && !Array.isArray(rawZip) ? (rawZip as Record<string, unknown>) : null;
    const zipCode =
      rawZip == null || rawZip === ''
        ? rawZip
        : typeof rawZip === 'string'
          ? rawZip
          : String((rawZip as { value?: string; name?: string }).value ?? (rawZip as { name?: string }).name ?? '');
    const requestBody = {
      searchType: SearchType.placement,
      pageNumber: action.payload.pageNumber,
      pageSize: action.payload.pageSize,
      sortedColumn: action.payload.sortedColumn || undefined,
      multiSortedColumns: action.payload.multiSortedColumns,
      latitude: (zipObj?.latitude as number) ?? undefined,
      longitude: (zipObj?.longitude as number) ?? undefined,
      ...f,
      [PlacementSearchFilterName.zip]: zipCode,
      radius: f[PlacementSearchFilterName.radius] ? parseInt(String(f[PlacementSearchFilterName.radius]), 10) : 0,
    };
    const response = yield call(TrackWrapper, getAMIECategorySearch, requestBody);
    if (response) {
      yield put(
        associatedPlacementActions.setData({
          items: placementFlattenData(response.items),
          count: response.paging.total,
        }),
      );
    }
    response
      ? yield put(
        globalSearchActions.setSearchResults({
          items: placementFlattenData(response.items),
          count: response?.paging?.total,
          miscellaneous: {
            positionCount: 0,
            jobMatchHealth: response?.jobMatchHealth,
            jobInterestHealth: response?.jobInterestHealth,
          },
        }),
      )
      : yield put(globalSearchActions.reset());
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.APIRequestError,
        functionName: 'getPlacements',
        area: 'src/app/components/Placement/AssociatedPlacements/store/associatedPlacements.saga.ts',
      },
    });
  }
}

export function* associatedPlacementsSaga() {
  yield takeLatest(associatedPlacementActions.getPlacementsAction.type, getPlacements);
}
